import React, { useEffect, useState } from 'react'
import { Typography, Paper, Button } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import { Link, withRouter } from 'react-router-dom'
import firebase from '../firebase'
import { useTranslation } from 'react-i18next'

const styles = theme => ({
	main: {
		height: '100vh',
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'top center',
		[theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
			backgroundPosition: 'center center',
		},
	},
	content: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',
		[theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
			alignItems: 'flex-end',
			justifyContent: 'center',
		},
	},
	paper: {
		display: 'flex',
		flexDirection: 'column',
		width: '94%',
		margin: 'auto',
		alignItems: 'center',
		zIndex: 99999,
		padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
		[theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
			width: 400,
		},
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	submit: {
		padding: 12,
		marginTop: theme.spacing(3),
	},
})

function HomePage(props) {
	const { classes } = props
	const { t } = useTranslation()
	const [apptitle] = useState(localStorage.getItem('apptitle'))

	useEffect(() => {
		document.title = window.localStorage.getItem('apptitle')
	}, [])

	useEffect(() => {
		if (firebase.getCurrentUsername()) {
			window.location.href = '/dashboard'
			return null
		}
	}, [])

	return (
		<main className={classes.main} style={{ backgroundImage: `url(${localStorage.getItem('background')})` }}>
			<div className={classes.content}>
				<Paper className={classes.paper}>
					<Typography component="h1" variant="h5">
						{apptitle}
					</Typography>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="primary"
						component={Link}
						to="/login"
						className={classes.submit}>
						{t('login.label')}
					</Button>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="secondary"
						component={Link}
						to="/register"
						className={classes.submit}>
						{t('register.label')}
					</Button>
				</Paper>
			</div>
		</main>
	)

}

export default withRouter(withStyles(styles)(HomePage))